import { Component, OnInit, Injector, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { GenericBasicGUI } from 'src/model/class/component classes/generic-basic-gui';
import { GenericQueryResult } from 'src/model/class/general classes/generic-query-result';
import { HAlign, VAlign } from 'src/model/enum/enumCustomInterface';
import { ShapeLayout } from 'src/model/interface/shape-layout';
import { LogLevel } from 'src/components/shared-components/enum/enumLog';

@Component({
    selector: 'app-sql-table',
    templateUrl: './sql-table.component.html',
    styleUrls: ['./sql-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SQLTableComponent extends GenericBasicGUI implements OnInit {
  @ViewChild("sqlTable", {static: false}) sqlTable: DatatableComponent;

  _logContext: string = "Sql-table.component";

  public styles = {
  };

  public stylesChild = {
  };

  public panelStyle = {
  }

  public titleStyle = {
  };

  public headerStyle = {
  };

  public bodyStyle = {
  };

  public queryResult: GenericQueryResult = null;

  public cols = [];
  public rows = [];
  public exampleCols = [
    {name:"ExampleCol0", prop:"ExampleCol0"},
    {name:"ExampleCol1", prop:"ExampleCol1"},
    {name:"ExampleCol2", prop:"ExampleCol2"},
    {name:"ExampleCol3", prop:"ExampleCol3"}
  ];
  public exampleRows = [
    {ExampleCol0:"ExampleCell[0,0]", ExampleCol1:"ExampleCell[0,1]", ExampleCol2:"ExampleCell[0,2]", ExampleCol3:"ExampleCell[0,3]"},
    {ExampleCol0:"ExampleCell[1,0]", ExampleCol1:"ExampleCell[1,1]", ExampleCol2:"ExampleCell[1,2]", ExampleCol3:"ExampleCell[1,3]"},
    {ExampleCol0:"ExampleCell[2,0]", ExampleCol1:"ExampleCell[2,1]", ExampleCol2:"ExampleCell[2,2]", ExampleCol3:"ExampleCell[2,3]"},
    {ExampleCol0:"ExampleCell[3,0]", ExampleCol1:"ExampleCell[3,1]", ExampleCol2:"ExampleCell[3,2]", ExampleCol3:"ExampleCell[3,3]"},
  ];
  public headerHeight = 60;
  public columnsWidth = 0;

  constructor(injector: Injector) {
    super(injector);
  }

  async ngOnInit() {
    this.subscribeSettingServiceData();

    [this.styles, this.stylesChild] = super.HandleProperties(
      this.styles,
      this.stylesChild
    );
    this.styles["text-decoration"] = "none";

    this.updateTableContent();
    if(this.ComponentAPI.properties["RefreshInterval"] > 0){
      setInterval(() => {
        this.updateTableContent();
      }, this.ComponentAPI.properties["RefreshInterval"] * 1000);
    }
    this.setStyles();

    if(!this.ShowingInDesktopVersion){
    }

    if(this.boldForced) this.styles["font-weight"] = "bold";
  }

  ngOnDestroy() {
      this.onDestroyChildren();
  }

  private updateTableContent(){
    this.sendQuery();
  }

  private async sendQuery(){
    try{
      var newQueryResult = await this.genericQueryService
        .GetValidatedQuery(this.ComponentAPI.properties["Query"]);
      if(!newQueryResult?.errorMessage){
        if(newQueryResult != this.queryResult){
          this.queryResult = newQueryResult;

          let tempcols = [];
          let temprows = [];
          var row;

          for(var colIndex = 0; colIndex < this.queryResult.headers.length; colIndex++){
            tempcols.push({
              "prop": this.queryResult.headers[colIndex],
              "name": this.queryResult.headers[colIndex]
            });
          }
      
          for(var rowIndex = 0; rowIndex < this.queryResult.rows.length; rowIndex++){
            row = new Object();
            for(var colIndex = 0; colIndex < this.queryResult.headers.length; colIndex++){
              row[tempcols[colIndex].prop] = this.queryResult.rows[rowIndex][colIndex];
            };
            temprows.push(row);
          };

          this.cols = tempcols;
          this.rows = temprows;
        }
      } else {
        this.loggerService.log(
          LogLevel.LOG_ERROR,
          this._logContext,
          this._logContext,
          "sendQuery()",
          "Query error: " + newQueryResult.errorMessage
        );
        this.cols = this.exampleCols;
        this.rows = this.exampleRows;
      }
      this.columnsWidth = Math.floor((Number(this.ComponentAPI.properties["Width"].replace("px","")) - 35) / this.cols.length);
    } catch (err) {
      this.loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "sendQuery()",
        "Query failed: " + (err?.message ?? JSON.stringify(err))
      );
      this.cols = this.exampleCols;
      this.rows = this.exampleRows;
      this.columnsWidth = Math.floor((Number(this.ComponentAPI.properties["Width"].replace("px","")) - 35) / this.cols.length);
    }
  }

  private setStyles() : void{
    this.setPanelStyle();
    this.setTitleStyle();
    this.setHeaderStyle();
    this.setBodyStyle();
  }

  private setPanelStyle() : void {
    this.AssignBackgroundColor(
      this.panelStyle,
      this.ComponentAPI.properties["ShowBackground"],
      null,
      this.ComponentAPI.properties["BackColor"]
    );
  }

  private setTitleStyle() : void {
    this.titleStyle["visibility"] = this.toBool(this.ComponentAPI.properties["ShowText"]) ? "visible" : "hidden";

    this.AssignFlexAlignment(
      this.titleStyle,
      this.ComponentAPI.properties["HAlignment"],
      this.ComponentAPI.properties["VAlignment"]
    )

    this.AssignFont(
      this.titleStyle,
      this.ComponentAPI.properties["FontColor"],
      this.ComponentAPI.properties["FontFamily"],
      this.ComponentAPI.properties["FontSize"],
      this.ComponentAPI.properties["Bold"],
      this.ComponentAPI.properties["Italic"],
      this.ComponentAPI.properties["Underline"],
      this.ComponentAPI.properties["Strikeout"]
    );
  }

  private setHeaderStyle() : void {
    if(this.toBool(this.ComponentAPI.properties["ShowHeader"])){
      this.AssignBackgroundColor(
        this.headerStyle,
        this.ComponentAPI.properties["ShowHeaderBackground"],
        null,
        this.ComponentAPI.properties["HeaderBackColor"]
      );
  
      this.AssignFlexAlignment(
        this.headerStyle,
        this.ComponentAPI.properties["HeaderHAlignment"],
        this.ComponentAPI.properties["HeaderVAlignment"]
      );
      
      this.AssignFont(
        this.headerStyle,
        this.ComponentAPI.properties["HeaderFontColor"],
        this.ComponentAPI.properties["HeaderFontFamily"],
        this.ComponentAPI.properties["HeaderFontSize"],
        this.ComponentAPI.properties["HeaderBold"],
        this.ComponentAPI.properties["HeaderItalic"],
        this.ComponentAPI.properties["HeaderUnderline"],
        this.ComponentAPI.properties["HeaderStrikeout"]
      );
      this.headerHeight = Number(this.headerStyle["font-size"].replace("px","").replace("pt","")) * 4;
    } else {
      this.headerHeight = 0;
    }
  }

  private setBodyStyle() : void {
    this.AssignBackgroundColor(
      this.bodyStyle,
      this.ComponentAPI.properties["ShowBodyBackground"],
      null,
      this.ComponentAPI.properties["BodyBackColor"]
    );

    this.AssignFlexAlignment(
      this.bodyStyle,
      this.ComponentAPI.properties["BodyHAlignment"],
      this.ComponentAPI.properties["BodyVAlignment"]
    );

    this.AssignFont(
      this.bodyStyle,
      this.ComponentAPI.properties["BodyFontColor"],
      this.ComponentAPI.properties["BodyFontFamily"],
      this.ComponentAPI.properties["BodyFontSize"],
      this.ComponentAPI.properties["BodyBold"],
      this.ComponentAPI.properties["BodyItalic"],
      this.ComponentAPI.properties["BodyUnderline"],
      this.ComponentAPI.properties["BodyStrikeout"]
    );
  }
  
  public getRowHeight = (row: any) : number => {
    // let maxLength = 0;
    // let colNumber = -1;
    // for(var key in row){
    //   colNumber++;
    //   if(row.hasOwnProperty(key)){
    //     if(row[key].length > maxLength) maxLength = row[key].length;
    //   }
    // }
    // let fontSize = this.getCellStyle(colNumber, );
    // return Math.ceil(maxLength * 2 / this.columnsWidth);
    return 50;
  }

  public getCellStyle(column: number, value: string): any{
    let shapeLayoutSet: boolean = false;
    let tmpStyle = {

    };
    for (const sLayout of this.ComponentAPI.shapeLayout.filter((sl) => sl["sqlColumn"] === column)) {
      if(this.isValueIncludedIntoRange(sLayout, value)){
        this.AssignBackgroundColor(
          tmpStyle,
          null,
          sLayout.transparent,
          sLayout.backColor
        );
        
        this.AssignFlexAlignment(
          tmpStyle,
          sLayout.hAlignment,
          sLayout.vAlignment
        );

        this.AssignFont(
          tmpStyle,
          sLayout.fontColor,
          sLayout.fontName,
          sLayout.fontSize.toString(),
          sLayout.fontBold,
          sLayout.fontItalic,
          sLayout.fontUnderline,
          sLayout.fontStrike
        );

        shapeLayoutSet = true;
        break;
      }
    }
    return shapeLayoutSet ? tmpStyle : this.bodyStyle;
  }

  public onClickRefresh(): void {
    this.updateTableContent();
  }
}
